import PadraoService from '@/modules/services/padrao.service'
import * as msg from '../mensagens/filial.msg'

class FiliaisService extends PadraoService {
  constructor() {
    // Rota, Biblioteca de mensagens
    super('filiais', msg)
  }
}

export default new FiliaisService()
